
// ProductContext
import { createContext, useContext, useEffect, useReducer,useState } from "react";
import axios from 'axios'
import reduser from "../Reducer/productReducer";

const AppContext = createContext();

const API_HOST='https://backend.avansisbd.com';
// const API_HOST='https://backend.ajuaub.edu.bd';
// const API_HOST='http://127.0.0.1:8000';

const initialState ={
    isLoading: false,
    isError: false,
    products: [],

    singelProductLoading:false,
    singleProduct:[],
    
    isLoadingApiData:false,
    apiData:[],

    isLoadingNEV:false,
    getNewsEventData:[],

    isLoadingJob:false,
    jobData:[],

    isLoaadingAvansis:false,
    Avansis:[],

    wellcomMsg:[],
    devHistory:[],
    productCategory:[],

    

}

const AppProvider = ({ children }) =>{

    const [state, dispatch] = useReducer(reduser,initialState);

    const getAvansisData = async (url) =>{
        dispatch({type:'SET_LOADIN_AVANSIS_DATA'})
        try {
            const res = await axios.get(API_HOST+'/avasisbd/')
            const Avansis = await res.data;
            dispatch({type:'SET_GET_AVANSIS_DATA', payload:Avansis})
        } catch (error) {
            dispatch({type:'SET_AVANSIS_ERROR'})
        }
    }
    
    useEffect(()=>{
        getAvansisData('/avasisbd/')
    },[])



    const getWellcomMsg = async () =>{
        try {
            const res = await axios.get(API_HOST+'/wmsg/')
            const msg = await res.data;
            dispatch({type:'SET_GET_MSG_DATA', payload:msg})
        } catch (error) {
        }
    }

    const getDevHistory = async()=>{
        try {
            const res = await axios.get(API_HOST+'/devhistory/')
            const history = await res.data;
            dispatch({type:'SET_DEVHISTORY_DATA', payload:history})
        } catch (error) {
        }
    }
    
    const getProductCategory = async () =>{
        try {
            const res = await axios.get(API_HOST+'/pcategory/')
            const pCategory = await res.data;
            dispatch({type:'SET_GET_PCATEGORY_DATA', payload:pCategory})
        } catch (error) {
            
        }
    }   
    
//Get All product 
    const getProducts = async (url)=>{
        dispatch({type:"SET_LOADING"})
        try {
            const res = await axios.get(url);
            const products = await res.data;
            // console.log(products);
            dispatch({type:"SET_API_DATA", payload:products})
            } catch (error) {
            dispatch({type:"AVANSISBD_API_ERROR"})    
        }    
};

    useEffect( ()=>{
        getProducts(API_HOST+'/products/')
    },[]);


    const getSingleProduct = async (url) =>{
        dispatch({type:"SET_SINGLE_PRODUCT_LOADING"})
    try {
    const res = await axios.get(API_HOST+url);
    const sigleProduct = await res.data;
    dispatch({type:"SET_SINGLE_PRODUCT_API", payload:sigleProduct})
} catch (error) {
    dispatch({type:"SINGLE_PRODUCT_API_ERROR"})
}
}
    // Get any Api data 

    const getApiData = async (url) =>{
        dispatch({type:'SET_LOADIN_API_DATA'})
        try {
            const res = await axios.get(API_HOST+url)
            const anydata = await res.data;
            dispatch({type:'SET_GET_ANY_DATA', payload:anydata})
        } catch (error) {
            dispatch({type:'SET_GET_ERROR'})
        }
    }    
    const getNewsEvent = async (url) =>{
        dispatch({type:'SET_LOADIN_NEV_DATA'})
        try {
            const res = await axios.get(API_HOST+url)
            const newsEvent = await res.data;
            dispatch({type:'SET_GET_NEV_DATA', payload:newsEvent})
        } catch (error) {
            dispatch({type:'SET_NEV_ERROR'})
        }
    }


    const jobRecruitment = async (url) =>{
        dispatch({type:'SET_LOADIN_JOB'})
        try {
            const res = await axios.get(API_HOST+url)
            const job = await res.data;
            dispatch({type:'SET_JOB_DATA', payload:job})
        } catch (error) {
            dispatch({type:'SET_JOB_ERROR'})
        }
    }

    //global Functon
    const [GetID, setGetID] = useState();
    const [GetName, setGetName] = useState();
    const onClicktoGet = (id,name)=>{
        // getProducts(API_HOST+'/products/')
        setGetID(id)
        setGetName(name)
        setScategoryName('')
        setScategoryId('')
    }
    const [ScategoryId,setScategoryId]=useState();
    const [ScategoryName,setScategoryName]=useState();
    const[categoryId,setCategoryId]=useState();

        const getScategory=(id,name,categoryId,categoryName)=>{
            setGetName(categoryName)
            setScategoryId(id)
            setScategoryName(name)
            setGetID('')
            setCategoryId(categoryId)
        }
        const [reload, setReload] = useState(false);
        const [Pid,setPid] = useState()
        const reloaddata =(id, tigar)=>{
            setPid(id)
            setReload(tigar)

        }
        
    const[ApiHost,setApiUrl] =useState();
        const getApiHost =()=>{
            setApiUrl(API_HOST);
        }
    return (
        <AppContext.Provider value ={{...state,jobRecruitment, getSingleProduct,getAvansisData, getApiData,getNewsEvent, onClicktoGet, GetID,GetName,getApiHost, ApiHost, getWellcomMsg, getProductCategory ,getDevHistory, getScategory,ScategoryId,ScategoryName,categoryId,reload,reloaddata,Pid}} >
        {children}
        </AppContext.Provider>
    );
};

//custom hook
const useAappContext = () =>{
    return useContext(AppContext);
}

export  {AppProvider, AppContext, useAappContext, }; 